import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsGeneratorModule } from '../inputs-generator/inputs-generator.module';
import { InputCheckboxesComponent } from './input-checkboxes.component';
import { createCustomElement } from '@angular/elements';
import { InputAddressComponent } from '../input-address/input-address.component';

@NgModule({
  declarations: [InputCheckboxesComponent],
  imports: [CommonModule, InputsGeneratorModule],
})
export class InputCheckboxesModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(InputCheckboxesComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-input-checkboxes', customComponent);
  }
}
